export default "__VITE_PUBLIC_ASSET__22e68b5a__"